import {
  X_ALLOW_COOKIES,
  X_BLOCK_COOKIES,
  X_CSRF_Token,
  generateEnvoyConsentHeader,
} from './oneTrust';

export function getDefaultRequestHeaders() {
  const headerMap = new Map();

  const csrfTokenMeta = document.querySelector('meta[name=csrf-token]');
  const csrfToken = csrfTokenMeta && csrfTokenMeta.getAttribute('content');
  const envoyConsentHeader = generateEnvoyConsentHeader();

  headerMap.set(X_ALLOW_COOKIES, envoyConsentHeader[X_ALLOW_COOKIES]);
  headerMap.set(X_BLOCK_COOKIES, envoyConsentHeader[X_BLOCK_COOKIES]);
  headerMap.set(X_CSRF_Token, csrfToken ?? '');

  return headerMap;
}
